module.exports = __webpack_public_path__ + "img/Inventory.7ad10bf9.svg";